export default "__VITE_ASSET__BNTD_X_k__"